import type { ReactNode, CSSProperties } from 'react';
import { colors } from './styles';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'neutral' | 'info' | 'purple';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  style?: CSSProperties;
}

const variantStyles: Record<BadgeVariant, { bg: string; text: string }> = {
  success: { bg: colors.successBgLight, text: colors.successAlt },
  warning: { bg: colors.warningBgLight, text: colors.warningAlt },
  danger: { bg: colors.dangerBgLight, text: colors.dangerAlt },
  neutral: { bg: colors.neutralBg, text: colors.neutralText },
  info: { bg: colors.infoBg, text: colors.infoText },
  purple: { bg: colors.purpleBg, text: colors.purpleText },
};

export function Badge({ children, variant = 'neutral', style }: BadgeProps) {
  const v = variantStyles[variant];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '999px',
        fontSize: '0.75rem',
        fontWeight: 600,
        background: v.bg,
        color: v.text,
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export function statusToBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'active':
    case 'approved':
    case 'paid':
    case 'renewed':
      return 'success';
    case 'pending':
    case 'in_training':
    case 'paused':
    case 'processing':
      return 'warning';
    case 'churned':
    case 'expired':
    case 'revoked':
    case 'terminated':
    case 'overdue':
      return 'danger';
    case 'draft':
      return 'info';
    default:
      return 'neutral';
  }
}
